var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-center-page"},[_c('div',{staticClass:"top-content"},[_c('SearchNav')],1),_c('div',{staticClass:"content flex"},[_c('div',{staticClass:"left-side flex column"},_vm._l((_vm.menu),function(item){return _c('div',{key:item.key,class:[
          'pointer menu-item',
          _vm.selected === item.key || _vm.$route.meta.sidebar === item.key ? 'menu-item-active' : '',
          item.justShow ? 'menu-level' : ''
        ],on:{"click":function($event){return _vm.changeItem(item.key, item.path)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0),_c('div',{staticClass:"right-side"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }